import { COOKIES, COOKIES_TIMES } from ".constants/cookies";
import { MIN_COINS_TO_NOTIFY_USER } from ".constants/texts";
import { some } from "lodash";
import { useEffect } from "react";
import { useCookies } from "react-cookie";

import {
  useABtestContext,
  useProfileContext,
  useUndressContext,
} from "@/providers";

import { useToastLowBalance } from "../toast-low-balance";

export function useToastLowBalanceEffect() {
  const { clickUndressStatus, undressingCost, undressings } =
    useUndressContext();
  const profile = useProfileContext();
  const showToastLowBalance = useToastLowBalance();
  const [cookies, setCookie] = useCookies([COOKIES.SHOWED_TOAST_USER_BALANCE]);
  const { AB_notification_balance } = useABtestContext();

  const hasPaid = some(undressings, "isPaid");

  useEffect(() => {
    // TODO: убрать AB тест после окончания
    // Показываем тоаст с уведомлением о недостаточном количестве монет, при соблюдении условий
    if (
      clickUndressStatus.isEndAllUndress &&
      AB_notification_balance &&
      !cookies.showedToastUserBalance &&
      profile &&
      hasPaid &&
      profile.coins - undressingCost <= MIN_COINS_TO_NOTIFY_USER
    ) {
      setCookie(COOKIES.SHOWED_TOAST_USER_BALANCE, "1", {
        maxAge: COOKIES_TIMES.WEEK_1,
      });
      showToastLowBalance();
    }
  }, [
    clickUndressStatus.isEndAllUndress,
    hasPaid,
    cookies.showedToastUserBalance,
    profile,
    undressingCost,
    setCookie,
    showToastLowBalance,
    AB_notification_balance,
  ]);
}
